import { LanguageCode } from '../models/enums/LanguageCode.enum';
import { __ } from './object.functions';

export class LanguageHelper {
    static Languages = [
        {
            value: LanguageCode.afZA,
            displayName: `Afrikaans (South Africa)`,
            googleTextToSpeechLanguageCode: 'af-ZA'
        },
        {
            value: LanguageCode.arAE,
            displayName: `Arabic (U.A.E.)`,
            googleTextToSpeechLanguageCode: 'ar-XA'
        },
        // {
        //     value: LanguageCode.arBH,
        //     displayName: `Arabic (Bahrain)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arDZ,
        //     displayName: `Arabic (Algeria)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arEG,
        //     displayName: `Arabic (Egypt)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arIQ,
        //     displayName: `Arabic (Iraq)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arf-JO,
        //     displayName: `Arabic (Jordan)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arKW,
        //     displayName: `Arabic (Kuwait)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arLB,
        //     displayName: `Arabic (Lebanon)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arLY,
        //     displayName: `Arabic (Libya)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arMA,
        //     displayName: `Arabic (Morocco)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arOM ,
        //     displayName: `Arabic (Oman)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arQA,
        //     displayName: `Arabic (Qatar)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arSA,
        //     displayName: `Arabic (Saudi Arabia)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arSY,
        //     displayName: `Arabic (Syria)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arTN,
        //     displayName: `Arabic (Tunisia)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arYE,
        //     displayName: `Arabic (Yemen)`,
        //     googleTextToSpeechLanguageCode: 'ar-XA'
        // },
        // {
        //     value: LanguageCode.arnCL,
        //     displayName: `Mapudungun (Chile)`
        // },
        // {
        //     value: LanguageCode.asIN,
        //     displayName: `Assamese (India)`
        // },
        // {
        //     value: LanguageCode.az,
        //     displayName: `Azeri`
        // },
        // {
        //     value: LanguageCode.azCyrlAZ,
        //     displayName: `Azeri (Cyrillic) (Azerbaijan)`
        // },
        // {
        //     value: LanguageCode.azLatnAZ,
        //     displayName: `Azeri (Latin) (Azerbaijan)`
        // },
        // {
        //     value: LanguageCode.baRU,
        //     displayName: `Bashkir (Russia)`
        // },
        // {
        //     value: LanguageCode.be,
        //     displayName: `Belarusian`
        // },
        // {
        //     value: LanguageCode.beBY,
        //     displayName: `Belarusian (Belarus)`
        // },
        {
            value: LanguageCode.bgBG,
            displayName: `Bulgarian (Bulgaria)`,
            googleTextToSpeechLanguageCode: 'bg-BG'
        },
        // {
        //     value: LanguageCode.bnBD,
        //     displayName: `Bengali (Bangladesh)`
        // },
        {
            value: LanguageCode.bnIN,
            displayName: `Bengali (India)`,
            googleTextToSpeechLanguageCode: 'bn-IN'
        },
        // {
        //     value: LanguageCode.boCN,
        //     displayName: `Tibetan (People's Republic of China)`
        // },
        // {
        //     value: LanguageCode.brFR,
        //     displayName: `Breton (France)`
        // },
        // {
        //     value: LanguageCode.bsCyrlBA,
        //     displayName: `Bosnian (Cyrillic) (Bosnia and Herzegovina)`
        // },
        // {
        //     value: LanguageCodebsLatnBA,
        //     displayName: `Bosnian (Latin) (Bosnia and Herzegovina)`
        // },
        // {
        //     value: LanguageCode.ca,
        //     displayName: `Catalan`
        // },
        {
            value: LanguageCode.caES,
            displayName: `Catalan (Catalan)`,
            googleTextToSpeechLanguageCode: 'ca-ES'
        },
        // {
        //     value: LanguageCodeLanguageCode.coFR,
        //     displayName: `Corsican (France)`
        // },
        // {
        //     value: LanguageCode.cs,
        //     displayName: `Czech`,
        // },
        {
            value: LanguageCode.csCZ,
            displayName: `Czech (Czech Republic)`,
            googleTextToSpeechLanguageCode: 'cs-CZ'
        },
        // {
        //     value: LanguageCode.cyGB,
        //     displayName: `Welsh (United Kingdom)`
        // },
        // {
        //     value: LanguageCode.da,
        //     displayName: `Danish`
        // },
        {
            value: LanguageCode.daDK,
            displayName: `Danish (Denmark)`,
            googleTextToSpeechLanguageCode: 'da-DK'
        },
        // {
        //     value: LanguageCode.de,
        //     displayName: `German`
        // },
        // {
        //     value: LanguageCode.deAT,
        //     displayName: `German (Austria)`
        // },
        // {
        //     value: LanguageCode.deCH,
        //     displayName: `German (Switzerland)`
        // },
        {
            value: LanguageCode.deDE,
            displayName: `German (Germany)`,
            googleTextToSpeechLanguageCode: 'de-DE'
        },
        // {
        //     value: LanguageCode.deLI,
        //     displayName: `German (Liechtenstein)`
        // },
        // {
        //     value: LanguageCode.deLU,
        //     displayName: `German (Luxembourg)`
        // },
        // {
        //     value: LanguageCode.dsbDE,
        //     displayName: `Lower Sorbian (Germany)`
        // },
        // {
        //     value: LanguageCode.dv,
        //     displayName: `Divehi`
        // },
        // {
        //     value: LanguageCode.dvMV,
        //     displayName: `Divehi (Maldives)`
        // },
        // {
        //     value: LanguageCode.el,
        //     displayName: `Greek`
        // },
        {
            value: LanguageCode.elGR,
            displayName: `Greek (Greece)`,
            googleTextToSpeechLanguageCode: 'el-GR'
        },
        // {
        //     value: LanguageCode.en,
        //     displayName: `English`
        // },
        // {
        //     value: LanguageCode.en029,
        //     displayName: `English (Caribbean)`
        // },
        // {
        //     value: LanguageCode.enAU,
        //     displayName: `English (Australia)`
        // },
        // {
        //     value: LanguageCode.enBZ,
        //     displayName: `English (Belize)`
        // },
        // {
        //     value: LanguageCode.enCA,
        //     displayName: `English (Canada)`
        // },
        {
            value: LanguageCode.enGB,
            displayName: `English (United Kingdom)`,
            googleTextToSpeechLanguageCode: 'en-GB'
        },
        // {
        //     value: LanguageCode.enIE,
        //     displayName: `English (Ireland)`
        // },
        // {
        //     value: LanguageCode.enIN,
        //     displayName: `English (India)`
        // },
        // {
        //     value: LanguageCode.enJM,
        //     displayName: `English (Jamaica)`
        // },
        // {
        //     value: LanguageCode.enMY,
        //     displayName: `English (Malaysia)`
        // },
        // {
        //     value: LanguageCode.enNZ,
        //     displayName: `English (New Zealand)`
        // },
        // {
        //     value: LanguageCode.enPH,
        //     displayName: `English (Republic of the Philippines)`
        // },
        // {
        //     value: LanguageCode.enSG,
        //     displayName: `English (Singapore)`
        // },
        // {
        //     value: LanguageCode.enTT,
        //     displayName: `English (Trinidad and Tobago)`
        // },
        {
            value: LanguageCode.enUS,
            displayName: `English (United States)`,
            googleTextToSpeechLanguageCode: 'en-US'
        },
        // {
        //     value: LanguageCode.enZA,
        //     displayName: `English (South Africa)`
        // },
        // {
        //     value: LanguageCode.enZW,
        //     displayName: `English (Zimbabwe)`
        // },
        // {
        //     value: LanguageCode.es,
        //     displayName: `Spanish`
        // },
        // {
        //     value: LanguageCode.esAR,
        //     displayName: `Spanish (Argentina)`
        // },
        // {
        //     value: LanguageCode.,esBO,
        //     displayName: `Spanish (Bolivia)`
        // },
        // {
        //     value: LanguageCode.esCL,
        //     displayName: `Spanish (Chile)`
        // },
        // {
        //     value: LanguageCode.esCO,
        //     displayName: `Spanish (Colombia)`
        // },
        // {
        //     value: LanguageCode.esCR,
        //     displayName: `Spanish (Costa Rica)`
        // },
        // {
        //     value: LanguageCode.esDO,
        //     displayName: `Spanish (Dominican Republic)`
        // },
        // {
        //     value: LanguageCode.esEC,
        //     displayName: `Spanish (Ecuador)`
        // },
        {
            value: LanguageCode.esES,
            displayName: `Spanish (Spain)`,
            googleTextToSpeechLanguageCode: 'es-ES'
        },
        // {
        //     value: LanguageCode.esGT,
        //     displayName: `Spanish (Guatemala)`
        // },
        // {
        //     value: LanguageCode.esHN,
        //     displayName: `Spanish (Honduras)`
        // },
        // {
        //     value: LanguageCode.esMX,
        //     displayName: `Spanish (Mexico)`
        // },
        // {
        //     value: LanguageCode.esNI,
        //     displayName: `Spanish (Nicaragua)`
        // },
        // {
        //     value: LanguageCode.esPA,
        //     displayName: `Spanish (Panama)`
        // },
        // {
        //     value: LanguageCode.esPE,
        //     displayName: `Spanish (Peru)`
        // },
        // {
        //     value: LanguageCode.esPR,
        //     displayName: `Spanish (Puerto Rico)`
        // },
        // {
        //     value: LanguageCode.esPY,
        //     displayName: `Spanish (Paraguay)`
        // },
        // {
        //     value: LanguageCode.esSV,
        //     displayName: `Spanish (El Salvador)`
        // },
        // {
        //     value: LanguageCode.esUS,
        //     displayName: `Spanish (United States)`
        // },
        // {
        //     value: LanguageCode.esUY,
        //     displayName: `Spanish (Uruguay)`
        // },
        // {
        //     value: LanguageCode.esVE,
        //     displayName: `Spanish (Venezuela)`
        // },
        // {
        //     value: LanguageCode.et,
        //     displayName: `Estonian`
        // },
        // {
        //     value: LanguageCode.etEE,
        //     displayName: `Estonian (Estonia)`
        // },
        // {
        //     value: LanguageCode.eu,
        //     displayName: `Basque`
        // },
        // {
        //     value: LanguageCode.euES.`,
        //     displayName: `Basque (Basque)`
        // },
        // {
        //     value: LanguageCode.fa,
        //     displayName: `Persian`
        // },
        // {
        //     value: LanguageCode.faIR,
        //     displayName: `Persian (Iran)`
        // },
        // {
        //     value: LanguageCode.fi,
        //     displayName: `Finnish`
        // },
        {
            value: LanguageCode.fiFI,
            displayName: `Finnish (Finland)`,
            googleTextToSpeechLanguageCode: 'fi-FI'
        },
        {
            value: LanguageCode.filPH,
            displayName: `Filipino (Philippines)`,
            googleTextToSpeechLanguageCode: 'fil-PH'
        },
        // {
        //     value: LanguageCode.fo,
        //     displayName: `Faroese`
        // },
        // {
        //     value: LanguageCode.foFO,
        //     displayName: `Faroese (Faroe Islands)`
        // },
        // {
        //     value: LanguageCode.fr,
        //     displayName: `French`
        // },
        // {
        //     value: LanguageCode.frBE,
        //     displayName: `French (Belgium)`
        // },
        {
            value: LanguageCode.frCA,
            displayName: `French (Canada)`,
            googleTextToSpeechLanguageCode: 'fr-CA'
        },
        // {
        //     value: LanguageCode fr-CH`,
        //     displayName: `French (Switzerland)`
        // },
        {
            value: LanguageCode.frFR,
            displayName: `French (France)`,
            googleTextToSpeechLanguageCode: 'fr-FR'
        },
        // {
        //     value: LanguageCode.frLU,
        //     displayName: `French (Luxembourg)`
        // },
        // {
        //     value: LanguageCode.frMC,
        //     displayName: `French (Principality of Monaco)`
        // },
        // {
        //     value: LanguageCode.fyNL,
        //     displayName: `Frisian (Netherlands)`
        // },
        // {
        //     value: LanguageCode.gaIE,
        //     displayName: `Irish (Ireland)`
        // },
        // {
        //     value: LanguageCode.gdGB,
        //     displayName: `Scottish Gaelic (United Kingdom)`
        // },
        // {
        //     value: LanguageCode.gl,
        //     displayName: `Galician`
        // },
        {
            value: LanguageCode.glES,
            displayName: `Galician (Galician)`,
            googleTextToSpeechLanguageCode: 'gl-ES'
        },
        // {
        //     value: LanguageCode.gswFR,
        //     displayName: `Alsatian (France)`
        // },
        // {
        //     value: LanguageCode.gu,
        //     displayName: `Gujarati`
        // },
        // {
        //     value: LanguageCode.guIN,
        //     displayName: `Gujarati (India)`
        // },
        // {
        //     value: LanguageCode.haLatnNG,
        //     displayName: `Hausa (Latin) (Nigeria)`
        // },
        // {
        //     value: LanguageCode.he,
        //     displayName: `Hebrew`
        // },
        {
            value: LanguageCode.heIL,
            displayName: `Hebrew (Israel)`,
            googleTextToSpeechLanguageCode: 'he-IL'
        },
        // {
        //     value: LanguageCode.hi,
        //     displayName: `Hindi`
        // },
        {
            value: LanguageCode.hiIN,
            displayName: `Hindi (India)`,
            googleTextToSpeechLanguageCode: 'hi-IN'
        },
        // {
        //     value: LanguageCode.hr,
        //     displayName: `Croatian`
        // },
        // {
        //     value: LanguageCode.hrBA,
        //     displayName: `Croatian (Latin) (Bosnia and Herzegovina)`
        // },
        // {
        //     value: LanguageCode.hrHR,
        //     displayName: `Croatian (Croatia)`
        // },
        // {
        //     value: LanguageCode.hsbDE,
        //     displayName: `Upper Sorbian (Germany)`
        // },
        // {
        //     value: LanguageCode.hu,
        //     displayName: `Hungarian`
        // },
        {
            value: LanguageCode.huHU,
            displayName: `Hungarian (Hungary)`,
            googleTextToSpeechLanguageCode: 'hu-HU'
        },
        // {
        //     value: LanguageCode.hy,
        //     displayName: `Armenian`
        // },
        // {
        //     value: LanguageCode.hyAM,
        //     displayName: `Armenian (Armenia)`
        // },
        // {
        //     value: LanguageCode.id,
        //     displayName: `Indonesian`
        // },
        {
            value: LanguageCode.idID,
            displayName: `Indonesian (Indonesia)`,
            googleTextToSpeechLanguageCode: 'id-ID'
        },
        // {
        //     value: LanguageCode.igNG,
        //     displayName: `Igbo (Nigeria)`
        // },
        // {
        //     value: LanguageCode.iiCN,
        //     displayName: `Yi (People's Republic of China)`
        // },
        // {
        //     value: LanguageCode.is,
        //     displayName: `Icelandic`
        // },
        {
            value: LanguageCode.isIS,
            displayName: `Icelandic (Iceland)`,
            googleTextToSpeechLanguageCode: 'is-IS'
        },
        // {
        //     value: LanguageCode.it,
        //     displayName: `Italian`
        // },
        // {
        //     value: LanguageCode.it-CH,
        //     displayName: `Italian (Switzerland)`
        // },
        {
            value: LanguageCode.itIT,
            displayName: `Italian (Italy)`,
            googleTextToSpeechLanguageCode: 'it-IT'
        },
        // {
        //     value: LanguageCode.iuCansCA,
        //     displayName: `Inuktitut (Syllabics) (Canada)`
        // },
        // {
        //     value: LanguageCode.iuLatnCA,
        //     displayName: `Inuktitut (Latin) (Canada)`
        // },
        // {
        //     value: LanguageCode.ja,
        //     displayName: `Japanese`
        // },
        {
            value: LanguageCode.jaJP,
            displayName: `Japanese (Japan)`,
            googleTextToSpeechLanguageCode: 'ja-JP'
        },
        // {
        //     value: LanguageCode.ka,
        //     displayName: `Georgian`
        // },
        // {
        //     value: LanguageCode,kaGE,
        //     displayName: `Georgian (Georgia)`
        // },
        // {
        //     value: LanguageCode.kk,
        //     displayName: `Kazakh`
        // },
        // {
        //     value: LanguageCode.kkKZ,
        //     displayName: `Kazakh (Kazakhstan)`
        // },
        // {
        //     value: LanguageCode.klGL,
        //     displayName: `Greenlandic (Greenland)`
        // },
        // {
        //     value: LanguageCode.kmKH,
        //     displayName: `Khmer (Cambodia)`
        // },
        // {
        //     value: LanguageCode.kn,
        //     displayName: `Kannada`
        // },
        // {
        //     value: LanguageCode.knIN,
        //     displayName: `Kannada (India)`
        // },
        // {
        //     value: LanguageCode.ko,
        //     displayName: `Korean`
        // },
        {
            value: LanguageCode.koKR,
            displayName: `Korean (Korea)`,
            googleTextToSpeechLanguageCode: 'ko-KR'
        },
        // {
        //     value: LanguageCode.kok,
        //     displayName: `Konkani`
        // },
        // {
        //     value: LanguageCode.kokIN,
        //     displayName: `Konkani (India)`
        // },
        // {
        //     value: LanguageCode.ky,
        //     displayName: `Kyrgyz`
        // },
        // {
        //     value: LanguageCode.kyKG,
        //     displayName: `Kyrgyz (Kyrgyzstan)`
        // },
        {
            value: LanguageCode.laVA,
            displayName: `Latin (Vatican City)`,
            googleTextToSpeechLanguageCode: 'de-DE'
        },
        // {
        //     value: LanguageCode.lbLU,
        //     displayName: `Luxembourgish (Luxembourg)`
        // },
        // {
        //     value: LanguageCode.loLA,
        //     displayName: `Lao (Lao P.D.R.)`
        // },
        // {
        //     value: LanguageCode.lt,
        //     displayName: `Lithuanian`,
        // },
        {
            value: LanguageCode.ltLT,
            displayName: `Lithuanian (Lithuania)`,
            googleTextToSpeechLanguageCode: 'lt-LT'
        },
        // {
        //     value: LanguageCode.lv,
        //     displayName: `Latvian`
        // },
        {
            value: LanguageCode.lvLV,
            displayName: `Latvian (Latvia)`,
            googleTextToSpeechLanguageCode: 'lv-LV'
        },
        // {
        //     value: LanguageCode.miNZ,
        //     displayName: `Maori (New Zealand)`
        // },
        // {
        //     value: LanguageCode.mk,
        //     displayName: `Macedonian`
        // },
        // {
        //     value: LanguageCode.mkMK,
        //     displayName: `Macedonian (Former Yugoslav Republic of Macedonia)`
        // },
        // {
        //     value: LanguageCode.mlIN,
        //     displayName: `Malayalam (India)`
        // },
        // {
        //     value: LanguageCode.mn,
        //     displayName: `Mongolian`
        // },
        // {
        //     value: LanguageCode.mnMN,
        //     displayName: `Mongolian (Cyrillic) (Mongolia)`
        // },
        // {
        //     value: LanguageCode.mnMongCN,
        //     displayName: `Mongolian (Traditional Mongolian) (People's Republic of China)`
        // },
        // {
        //     value: LanguageCode.mohCA,
        //     displayName: `Mohawk (Canada)`
        // },
        // {
        //     value: LanguageCode.mr,
        //     displayName: `Marathi`
        // },
        // {
        //     value: LanguageCode.mrIN,
        //     displayName: `Marathi (India)`
        // },
        // {
        //     value: LanguageCode.ms,
        //     displayName: `Malay`
        // },
        // {
        //     value: LanguageCode.msBN,
        //     displayName: `Malay (Brunei Darussalam)`
        // },
        {
            value: LanguageCode.msMY,
            displayName: `Malay (Malaysia)`,
            googleTextToSpeechLanguageCode: 'ms-MY'
        },
        // {
        //     value: LanguageCode.mtMT,
        //     displayName: `Maltese (Malta)`
        // },
        {
            value: LanguageCode.nbNO,
            displayName: `Norwegian, Bokmål (Norway)`,
            googleTextToSpeechLanguageCode: 'nb-NO'
        },
        // {
        //     value: LanguageCode.neNP,
        //     displayName: `Nepali (Nepal)`
        // },
        // {
        //     value: LanguageCode.nl,
        //     displayName: `Dutch`
        // },
        {
            value: LanguageCode.nlBE,
            displayName: `Dutch (Belgium)`,
            googleTextToSpeechLanguageCode: 'nl-BE'
        },
        {
            value: LanguageCode.nlNL,
            displayName: `Dutch (Netherlands)`,
            googleTextToSpeechLanguageCode: 'nl-NL'
        },
        // {
        //     value: LanguageCode.nnNO,
        //     displayName: `Norwegian, Nynorsk (Norway)`
        // },
        // {
        //     value: LanguageCode.no,
        //     displayName: `Norwegian`
        // },
        // {
        //     value: LanguageCode.nsoZA,
        //     displayName: `Sesotho sa Leboa (South Africa)`
        // },
        // {
        //     value: LanguageCode.ocFR,
        //     displayName: `Occitan (France)`
        // },
        // {
        //     value: LanguageCode.orIN,
        //     displayName: `Oriya (India)`
        // },
        // {
        //     value: LanguageCode.pa,
        //     displayName: `Punjabi`
        // },
        // {
        //     value: LanguageCode.paIN,
        //     displayName: `Punjabi (India)`
        // },
        // {
        //     value: LanguageCode.pl,
        //     displayName: `Polish`
        // },
        {
            value: LanguageCode.plPL,
            displayName: `Polish (Poland)`,
            googleTextToSpeechLanguageCode: 'pl-PL'
        },
        // {
        //     value: LanguageCode.prsAF,
        //     displayName: `Dari (Afghanistan)`
        // },
        // {
        //     value: LanguageCode.psAF,
        //     displayName: `Pashto (Afghanistan)`
        // },
        // {
        //     value: LanguageCode.pt,
        //     displayName: `Portuguese`
        // },
        {
            value: LanguageCode.ptBR,
            displayName: `Portuguese (Brazil)`,
            googleTextToSpeechLanguageCode: 'pt-BR'
        },
        {
            value: LanguageCode.ptPT,
            displayName: `Portuguese (Portugal)`,
            googleTextToSpeechLanguageCode: 'pt-PT'
        },
        // {
        //     value: LanguageCode.qutGT,
        //     displayName: `K'iche (Guatemala)`
        // },
        // {
        //     value: LanguageCode.quzBO,
        //     displayName: `Quechua (Bolivia)`
        // },
        // {
        //     value: LanguageCode.quzEC,
        //     displayName: `Quechua (Ecuador)`
        // },
        // {
        //     value: LanguageCode.quzPE,
        //     displayName: `Quechua (Peru)`
        // },
        // {
        //     value: LanguageCode.rmCH,
        //     displayName: `Romansh (Switzerland)`
        // },
        // {
        //     value: LanguageCode.ro,
        //     displayName: `Romanian`,
        //     googleTextToSpeechLanguageCode: 'ro-RO'
        // },
        {
            value: LanguageCode.roRO,
            displayName: `Romanian (Romania)`,
            googleTextToSpeechLanguageCode: 'ro-RO'
        },
        // {
        //     value: LanguageCode.ru,
        //     displayName: `Russian`
        // },
        {
            value: LanguageCode.ruRU,
            displayName: `Russian (Russia)`,
            googleTextToSpeechLanguageCode: 'ru-RU'
        },
        // {
        //     value: LanguageCode.rwRW,
        //     displayName: `Kinyarwanda (Rwanda)`
        // },
        // {
        //     value: LanguageCode.sa,
        //     displayName: `Sanskrit`
        // },
        // {
        //     value: LanguageCode.saIN,
        //     displayName: `Sanskrit (India)`
        // },
        // {
        //     value: LanguageCode.sahRU,
        //     displayName: `Yakut (Russia)`
        // },
        // {
        //     value: LanguageCode.seFI,
        //     displayName: `Sami (Northern) (Finland)`
        // },
        // {
        //     value: LanguageCode.seNO,
        //     displayName: `Sami (Northern) (Norway)`
        // },
        // {
        //     value: LanguageCode.seSE,
        //     displayName: `Sami (Northern) (Sweden)`
        // },
        // {
        //     value: LanguageCode.siLK,
        //     displayName: `Sinhala (Sri Lanka)`
        // },
        // {
        //     value: LanguageCode.sk,
        //     displayName: `Slovak`
        // },
        {
            value: LanguageCode.skSK,
            displayName: `Slovak (Slovakia)`,
            googleTextToSpeechLanguageCode: 'sk-SK'
        },
        // {
        //     value: LanguageCode.sl,
        //     displayName: `Slovenian`
        // },
        // {
        //     value: LanguageCode.slSI,
        //     displayName: `Slovenian (Slovenia)`
        // },
        // {
        //     value: LanguageCode.smaNO,
        //     displayName: `Sami (Southern) (Norway)`
        // },
        // {
        //     value: LanguageCode.smaSE,
        //     displayName: `Sami (Southern) (Sweden)`
        // },
        // {
        //     value: LanguageCode.smjNO,
        //     displayName: `Sami (Lule) (Norway)`
        // },
        // {
        //     value: LanguageCode.smjSE`,
        //     displayName: `Sami (Lule) (Sweden)`
        // },
        // {
        //     value: LanguageCode.smnFI,
        //     displayName: `Sami (Inari) (Finland)`
        // },
        // {
        //     value: LanguageCode.smsFI,
        //     displayName: `Sami (Skolt) (Finland)`
        // },
        // {
        //     value: LanguageCode.sq,
        //     displayName: `Albanian`
        // },
        // {
        //     value: LanguageCode.sqAL,
        //     displayName: `Albanian (Albania)`
        // },
        // {
        //     value: LanguageCode.sr,
        //     displayName: `Serbian`
        // },
        // {
        //     value: LanguageCode.srCyrlBA,
        //     displayName: `Serbian (Cyrillic) (Bosnia and Herzegovina)`
        // },
        // {
        //     value: LanguageCode.srCyrlCS,
        //     displayName: `Serbian (Cyrillic) (Serbia and Montenegro (Former))`
        // },
        // {
        //     value: LanguageCode.srCyrlME,
        //     displayName: `Serbian (Cyrillic) (Montenegro)`
        // },
        {
            value: LanguageCode.srCyrlRS,
            displayName: `Serbian (Cyrillic) (Serbia)`,
            googleTextToSpeechLanguageCode: 'sr-RS'
        },
        // {
        //     value: LanguageCode.srLatnBA,
        //     displayName: `Serbian (Latin) (Bosnia and Herzegovina)`
        // },
        // {
        //     value: LanguageCode.srLatnCS,
        //     displayName: `Serbian (Latin) (Serbia and Montenegro (Former))`
        // },
        // {
        //     value: LanguageCode.srLatnME,
        //     displayName: `Serbian (Latin) (Montenegro)`
        // },
        // {
        //     value: LanguageCode.srLatnRS,
        //     displayName: `Serbian (Latin) (Serbia)`
        // },
        // {
        //     value: LanguageCode.sv,
        //     displayName: `Swedish`
        // },
        // {
        //     value: LanguageCode.svFI,
        //     displayName: `Swedish (Finland)`
        // },
        {
            value: LanguageCode.svSE,
            displayName: `Swedish (Sweden)`,
            googleTextToSpeechLanguageCode: 'sv-SE'
        },
        // {
        //     value: LanguageCode.sw,
        //     displayName: `Kiswahili`
        // },
        // {
        //     value: LanguageCode.swKE,
        //     displayName: `Kiswahili (Kenya)`
        // },
        // {
        //     value: LanguageCode.syr,
        //     displayName: `Syriac`
        // },
        // {
        //     value: LanguageCode.syrSY,
        //     displayName: `Syriac (Syria)`
        // },
        // {
        //     value: LanguageCode.ta,
        //     displayName: `Tamil`
        // },
        // {
        //     value: LanguageCode.taIN,
        //     displayName: `Tamil (India)`
        // },
        // {
        //     value: LanguageCode.te,
        //     displayName: `Telugu`
        // },
        // {
        //     value: LanguageCode.teIN,
        //     displayName: `Telugu (India)`
        // },
        // {
        //     value: LanguageCode.tgCyrlTJ,
        //     displayName: `Tajik (Cyrillic) (Tajikistan)`
        // },
        // {
        //     value: LanguageCode.th,
        //     displayName: `Thai`,
        //     googleTextToSpeechLanguageCode: 'th-TH'
        // },
        {
            value: LanguageCode.thTH,
            displayName: `Thai (Thailand)`,
            googleTextToSpeechLanguageCode: 'th-TH'
        },
        // {
        //     value: LanguageCode.tkTM,
        //     displayName: `Turkmen (Turkmenistan)`
        // },
        // {
        //     value: LanguageCode.tnZA,
        //     displayName: `Setswana (South Africa)`
        // },
        // {
        //     value: LanguageCode.tr,
        //     displayName: `Turkish`,
        //     googleTextToSpeechLanguageCode: 'tr-TR'
        // },
        {
            value: LanguageCode.trTR,
            displayName: `Turkish (Turkey)`,
            googleTextToSpeechLanguageCode: 'tr-TR'
        },
        // {
        //     value: LanguageCode.tt,
        //     displayName: `Tatar`
        // },
        // {
        //     value: LanguageCode.ttRU,
        //     displayName: `Tatar (Russia)`
        // },
        // {
        //     value: LanguageCode.tzmLatnDZ,
        //     displayName: `Tamazight (Latin) (Algeria)`
        // },
        // {
        //     value: LanguageCode.ugCN,
        //     displayName: `Uyghur (People's Republic of China)`
        // },
        // {
        //     value: LanguageCode.uk,
        //     displayName: `Ukrainian`,
        //     googleTextToSpeechLanguageCode: 'uk-UA'
        // },
        {
            value: LanguageCode.ukUA,
            displayName: `Ukrainian (Ukraine)`,
            googleTextToSpeechLanguageCode: 'uk-UA'
        },
        // {
        //     value: LanguageCode.ur,
        //     displayName: `Urdu`
        // },
        // {
        //     value: LanguageCode.urPK,
        //     displayName: `Urdu (Islamic Republic of Pakistan)`
        // },
        // {
        //     value: LanguageCode.uz,
        //     displayName: `Uzbek`
        // },
        // {
        //     value: LanguageCode.uzCyrlUZ,
        //     displayName: `Uzbek (Cyrillic) (Uzbekistan)`
        // },
        // {
        //     value: LanguageCode.uzLatnUZ,
        //     displayName: `Uzbek (Latin) (Uzbekistan)`
        // },
        // {
        //     value: LanguageCode.vi,
        //     displayName: `Vietnamese`
        // },
        {
            value: LanguageCode.viVN,
            displayName: `Vietnamese (Vietnam)`,
            googleTextToSpeechLanguageCode: 'vi-VN'
        },
        // {
        //     value: LanguageCode.woSN,
        //     displayName: `Wolof (Senegal)`
        // },
        // {
        //     value: LanguageCode.xhZA,
        //     displayName: `isiXhosa (South Africa)`
        // },
        // {
        //     value: LanguageCode.yoNG,
        //     displayName: `Yoruba (Nigeria)`
        // },
        {
            value: LanguageCode.zhHans,
            displayName: `Chinese (Simplified)`,
            googleTextToSpeechLanguageCode: 'zh-HANS'
        },
        {
            value: LanguageCode.zhHant,
            displayName: `Chinese (Traditional)`,
            googleTextToSpeechLanguageCode: 'zh-HANT'
        },
        // {
        //     value: LanguageCode.zh-CN,
        //     displayName: `Chinese (People's Republic of China)`
        // },
        // {
        //     value: LanguageCode.zhHK,
        //     displayName: `Chinese (Hong Kong S.A.R.)`
        // },
        // {
        //     value: LanguageCode.zhMO,
        //     displayName: `Chinese (Macao S.A.R.)`
        // },
        // {
        //     value: LanguageCode.zhSG,
        //     displayName: `Chinese (Singapore)`
        // },
        // {
        //     value: LanguageCode.zhTW,
        //     displayName: `Chinese (Taiwan)`,
        //     googleTextToSpeechLanguageCode: 'cmn-TW'
        // },
        // {
        //     value: LanguageCode.zuZA,
        //     displayName: `isiZulu (South Africa)`
        // }
    ]

    static GetLanguages() {
        return this.Languages;
    }

    /**
     * The languages google provides text to speech voices for, deduplicated by their text to
     * speech language code. Used to pick the voices of a related language for languages google
     * has no own voices for, e.g. the german voices for Latin.
     * @returns The languages with a distinct google text to speech language code
     */
    static GetTextToSpeechLanguages(): any[] {
        const languages: any[] = LanguageHelper.GetLanguages()
            .filter((language: any) => !__.IsNullOrUndefinedOrEmpty(language.googleTextToSpeechLanguageCode));

        return languages.filter((language: any, index: number) =>
            languages.findIndex((q: any) =>
                q.googleTextToSpeechLanguageCode === language.googleTextToSpeechLanguageCode) === index);
    }

    static GetLanguageByNameOrNull(displayName: string): any {
        const result = LanguageHelper.GetLanguages().find((language: any) => language.displayName === displayName);
        if (__.IsNullOrUndefinedOrEmpty(result)) {
            return null;
        }
        return result;
    }

    static GetLanguageByValueOrNull(value: string): any {
        const result = LanguageHelper.GetLanguages().find((language: any) => language.value === value);
        if (__.IsNullOrUndefinedOrEmpty(result)) {
            return null;
        }
        return result;
    }

    static GetLanguageByShortNameOrNull(value: string): any {
        const result = LanguageHelper.GetLanguages().find((language: any) => language.shortName === value);
        if (__.IsNullOrUndefinedOrEmpty(result)) {
            return null;
        }
        return result;
    }
}
